import { CSSProperties, ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  hover?: boolean;
  padding?: string | number;
}

export function Card({ children, className, style, hover, padding = '20px' }: CardProps) {
  return (
    <div
      className={`${hover ? 'cartao-com-hover' : ''} ${className ?? ''}`.trim()}
      style={{
        background: 'var(--cor-branco)',
        borderRadius: 'var(--raio-padrao)',
        boxShadow: 'var(--sombra-padrao)',
        border: '1px solid var(--cor-borda)',
        padding,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
